/**
 * Index route under Main. Logged-in users stay on `/` (PlayKaroLanding via Main layout).
 * Guests are handled by Main before the outlet renders.
 */
const DashboardRedirect = () => null

export default DashboardRedirect
